import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { SharedModule } from '../shared/shared.module'
import { FundManagementComponent } from './components/fund-management/fund-management.component'
import { KeyFactsComponent } from './components/key-facts/key-facts.component'
import { PerformanceComponent } from './components/performance/performance.component'
import { PriceComponent } from './components/price/price.component'
import { ProductSummaryComponent } from './components/product-summary/product-summary.component'
import { RatingsComponent } from './components/ratings/ratings.component'
import { OverviewComponent } from './overview.component'

@NgModule({
  declarations: [
    OverviewComponent,
    ProductSummaryComponent,
    FundManagementComponent,
    KeyFactsComponent,
    PerformanceComponent,
    RatingsComponent,
    PriceComponent,
  ],
  imports: [CommonModule, SharedModule],
  exports: [OverviewComponent],
  providers: [],
})
export class OverviewModule {}
